import { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';
import { isAppUpdateAvailable } from '../lib/pwa';
import { Button } from './ui/button';

export const PWAUpdateBanner = () => {
  const [visible, setVisible] = useState(isAppUpdateAvailable);
  useEffect(() => {
    const show = () => setVisible(true);
    window.addEventListener('pwa-update-ready', show);
    return () => window.removeEventListener('pwa-update-ready', show);
  }, []);
  useEffect(() => {
    document.documentElement.dataset.pwaUpdateReady = String(visible);
    return () => { delete document.documentElement.dataset.pwaUpdateReady; };
  }, [visible]);
  if (!visible) return null;
  return <div className="pwa-update-banner fixed inset-x-3 bottom-[calc(76px+env(safe-area-inset-bottom))] xl:bottom-4 xl:left-auto xl:right-4 xl:w-96 z-[60] rounded-md border border-red-200 bg-white shadow-lg p-3 flex items-center gap-3"
    role="status" data-testid="pwa-update-banner">
    <span className="min-w-0 flex-1 text-sm font-medium" data-testid="pwa-update-message">An update is ready.</span>
    <Button className="bg-red-600 hover:bg-red-700 text-white" data-testid="pwa-update-reload"
      onClick={() => { if (window.confirm('Reload now? Any unsaved entries will be lost.')) window.location.reload(); }}>
      <RefreshCw className="h-4 w-4" />Reload
    </Button>
    <Button variant="ghost" size="icon" aria-label="Update later" data-testid="pwa-update-later" onClick={() => setVisible(false)}><X className="h-4 w-4" /></Button>
  </div>;
};